// customer服务器，文档参考：https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=20618658
export const HOST = ['https://test-customer.ihuhoo.com', 'https://customer.tradeup.com'];
export const API = {
    fields: {
        cnArea: '/api/v1/account/field/area', // 国内省市区
        countryUS: '/api/v1/account/field/country_us',
        stateUS: '/api/v1/account/field/state_us',
        careerUS: '/api/v1/account/field/business_career_us',
        companyUS: '/api/v1/account/field/et_company',
        proofUs: '/api/v1/account/field/proof_us',
        country_us_group: '/api/v1/account/field/country_us_group'
    },

    // 文档参考：https://test-oauth.tigerfintech.com/ams/docs/Customer%20Support/index#req_268217fe6a7a4b54890eca0fd6c31658
    getRates: '/support/api/v1/pay/rate', // pricing 页面
    proofUrl: ':path',

    /**
     * 协议相关 https://wiki.tigerbrokers.net/pages/viewpage.action?pageId=45843480 @郭江帅
     */
    agreement: '/support/api/v1/agreement/:id', // 用户协议
    fileRetrieve: '/file/api/v1/file/retrieve', // 文件访问
    statement: '/support/api/v1/individual/statement/:id', // 服务和隐私声明

    appLink: '/support/api/v1/download/app', // app dowload link

    // 帮助中心
    help: {
        getList: '/support/api/v1/help/collections', // 获取帮助中心列表
        getListDetail: '/support/api/v1/help/collections/:id', // 获取帮助中心列表详情
        getQuestion: '/support/api/v1/help/questions', // 获取帮助中心问题列表
        search: '/support/api/v1/help/collections/search' // 搜索
    },

    web: {
        // 针对个人中心提供的专门接口
        // https://apidocs.tigerfintech.com/repository/1/api/master/apis/web/Web%E6%8E%A5%E5%8F%A3.json#/operations/get--api-v1-web-account-info
        accountInfo: '/api/v1/web/account/info'
    },

    // 获取美国官网协议
    disclaimers: '/support/api/v1/individual/website/usa-terms-and-conditions',
    /**
     * JWT 客服
     */
    getWebWidget: '/support/api/v1/chat/jwt' // 获取JWT_TOKEN_ENDPOINT
};
